import type { AcceptedBet } from '../../../store/slices/bets/types';

import type { ComputedBet } from './types';

export const getAcceptedBets = (computedBets: ComputedBet[]): AcceptedBet[] => {
  return computedBets.map((bet) => {
    return {
      amount: bet.value,
      betcode: bet.betId,
      errorCode: -1,
    };
  });
};
